import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Observable } from "rxjs";

import { INFRA_SETTINGS } from "@hermes/core-app-core";
import { InfraSettings } from "@hermes/core-env-infra";
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ENABLE_HCOM_GATEWAY, FeatureFlagFacade } from "@hermes/hermes-web-states-flipper-state";

@Injectable()
export class HComGatewayInterceptor implements HttpInterceptor {
    private readonly settings = inject<InfraSettings>(INFRA_SETTINGS);
    private readonly featureFlagFacade = inject(FeatureFlagFacade);

    private readonly isHComGatewayEnabled = toSignal(
        this.featureFlagFacade.isActivated(ENABLE_HCOM_GATEWAY),
        { initialValue: false },
    );

    public intercept<T, U>(
        request: HttpRequest<T>,
        next: HttpHandler,
    ): Observable<HttpEvent<U>> {
        if (this.isHComGatewayEnabled()) {
            let url = request.url;
            if (request.url.startsWith(this.settings.backendCSR)) {
                url = request.url.replace(
                    this.settings.backendCSR,
                    `${this.settings.frontend}/api`,
                );
            }

            if (
                this.settings.backendSSR &&
                request.url.startsWith(this.settings.backendSSR)
            ) {
                url = request.url.replace(
                    this.settings.backendSSR,
                    `${this.settings.hcomGatewaySSR}/api`,
                );
            }
            const updatedRequest = request.clone({ url });
            return next.handle(updatedRequest);
        }

        return next.handle(request);
    }
}
